import { render } from "./ShopRetailSales.vue?vue&type=template&id=e5a35266"
import script from "./ShopRetailSales.vue?vue&type=script&lang=ts"
export * from "./ShopRetailSales.vue?vue&type=script&lang=ts"
script.render = render

export default script